import { required, array, obj } from 'AppReact/schema';

export default {
    id: required('integer'),
    name: required('string'),
    units: array(obj({ id: required('integer'), number: required('string') }))
}

